export const registerData = {
  title: {
    en: 'Register',
    np: 'दर्ता गर्नुहोस्',
  },
  label: {
    name: {
      en: 'Full name:',
      np: 'पुरा नाम:',
    },
    phoneno: {
      en: 'Phone no:',
      np: 'फोन नम्बर:',
    },
    email: {
      en: 'Email:',
      np: 'ई-मेल ठेगाना:',
    },
    course: {
      en: 'Select course:',
      np: 'पाठ्यक्रम चयन गर्नुहोस्:',
    },
    photo: {
      en: 'Photo (PP size):',
      np: 'फोटो (पीपी साइज):',
    },
    marksheet: {
      en: 'SLC/SEE marksheet:',
      np: 'SLC/SEE मार्कसिट:',
    },
  },
  placeholder: {
    name: {
      en: 'Your full name',
      np: 'तपाईँको पुरा नाम',
    },
    phoneno: {
      en: 'Your phone number',
      np: 'तपाईँको फोन नम्बर',
    },
    email: {
      en: 'Your email address',
      np: 'तपाईँको ई-मेल ठेगाना',
    },
  },
  engineering: {
    en: 'Civil Engineering',
    np: 'सिभिल इन्जिनियरिङ',
  },
  agriculture: {
    en: 'Agriculture (Plant Science)',
    np: 'कृषि (वनस्पति विज्ञान)',
  },
  buttonText: {
    en: 'Register',
    np: 'दर्ता गर्नुहोस्',
  },

};
